// router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import AppLogin from '@/views/login/appLogin.vue';
import Index from '@/views/house/houseIndex.vue';
import Home from '@/views/index.vue';
import Error from '@/views/error/PageError.vue';
import HouseIndex from '@/views/house/houseIndex.vue';
import AddHouse from '@/views/im/addHouse.vue';
import HouseDetail from '@/views/house/houseDetail.vue';
import PdfViewer from '@/views/house/PdfViewer.vue';
import HouseCategory from '@/views/house/category/houseCategory.vue';
import HouseSearch from '@/views/house/search/houseSearch.vue';
import TestHouse from '@/views/house/detail/testCart.vue';
import HouseCart from '@/views/house/cart/houseCart.vue';
import HouseCustomerService from '@/views/house/customerService/houseCustomerService.vue';
import SubmitOrder from '@/views/house/order/submitOrder.vue';
import AddressInfo from '@/views/house/address/addressInfo.vue';
import My from '@/views/login/KsMy.vue';
import UserManage from '@/views/house/user/userManage.vue';
import WhiteListManage from '@/views/im/whiteListManage.vue';
import LoginRecord from '@/views/house/user/loginRecord.vue';
import HouseManage from '@/views/house/user/houseManage.vue';
import HouseDetailManage from '@/views/house/user/houseDetailManage.vue';
import AddUser from '@/views/house/user/addUser.vue';
import AddWhiteListManage from '@/views/im/addWhiteListManage.vue';
import MySelf from '@/views/house/my/mySelf.vue';
import AboutOur from '@/views/house/my/aboutOur.vue';
import MyLike from '@/views/house/my/myLike.vue';
import ZhongZhuan from '@/views/house/manage/zhongZhuan1.vue';
import MobileSystemManage from '@/views/house/manage/mobileSystemManage.vue';
import MobileUserManage from '@/views/house/manage/mobileUserManage.vue';
import MobileAddUser from '@/views/house/manage/mobileAddUser.vue';
import MobileLoginRecord from '@/views/house/manage/mobileLoginRecord.vue';
import UpdatePwd from '@/views/house/my/updatePwd.vue';
import UploadOss from '@/views/im/uploadOss.vue';


// 定义路由配置
const routes = [
  {
    path: '/appLogin',
    name: 'AppLogin',
    component: AppLogin,
    meta: { title: '登录' }
  },
  {
    path: '/updatePwd',
    name: 'UpdatePwd',
    component: UpdatePwd,
    meta: { title: '修改密码' }
  },
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { title: '首页' }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: '首页' }
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
    meta: { title: '错误页面' }
  },
  {
    path: '/houseIndex',
    name: 'HouseIndex',
    component: HouseIndex,
    meta: { title: '首页' }
  },
  {
    path: '/houseDetail/:houseId',
    name: 'HouseDetail',
    component: HouseDetail,
    meta: { title: '详情' }
  },
  {
    path: '/pdfViewer/:pdfUrl',
    name: 'PdfViewer',
    component: PdfViewer,
    meta: { title: 'pdf' }
  },
  {
    path: '/houseCategory',
    name: 'HouseCategory',
    component: HouseCategory,
    meta: { title: '分类' }
  },
  {
    path: '/houseSearch',
    name: 'HouseSearch',
    component: HouseSearch,
    meta: { title: '搜索' }
  },
  {
    path: '/testHouse',
    name: 'TestHouse',
    component: TestHouse,
  },
  {
    path: '/manage',
    name: 'Manage',
    component: ZhongZhuan,
  },
  {
    path: '/houseCart',
    name: 'HouseCart',
    component: HouseCart,
    meta: { title: '管理页面' },
    children: [
      {
        path: 'userManage',
        name: 'UserManage',
        component: UserManage,
        meta: { title: '账号管理' }
      },
      {
        path: 'whiteListManage',
        name: 'WhiteListManage',
        component: WhiteListManage,
        meta: { title: '黑名单管理' }
      },
      {
        path: 'houseManage',
        name: 'HouseManage',
        component: HouseManage,
        meta: { title: '别墅管理' }
      },
      {
        path: 'addUser',
        name: 'AddUser',
        component: AddUser,
        meta: { title: '添加账号' }
      },
      {
        path: 'addWhiteListManage',
        name: 'AddWhiteListManage',
        component: AddWhiteListManage,
        meta: { title: '添加黑名单' }
      },
      {
        path: 'addHouse',
        name: 'AddHouse',
        component: AddHouse,
        meta: { title: '添加别墅' }
      },
      {
        path: 'updHouse',
        name: 'UpdHouse',
        component: AddHouse,
        meta: { title: '修改别墅' }
      },
      {
        path: 'loginRecord',
        name: 'LoginRecord',
        component: LoginRecord,
        meta: { title: '登录记录' }
      },
      {
        path: 'houseDetailManage',
        name: 'HouseDetailManage',
        component: HouseDetailManage,
        meta: { title: '别墅详情' }
      },

    ]
  },
  {
    path: '/houseCustomerService',
    name: 'HouseCustomerService',
    component: HouseCustomerService,
    meta: { title: '添加客服' }
  },
  {
    path: '/submitOrder',
    name: 'SubmitOrder',
    component: SubmitOrder,
  },
  {
    path: '/submitOrder/:id',
    name: 'SubmitOrderWithParam',
    component: SubmitOrder,
  },
  {
    path: '/addressInfo/:id',
    name: 'AddressInfo',
    component: AddressInfo,
  },
  {
    path: '/my',
    name: 'My',
    component: My,
  },
  {
    path: '/mySelf',
    name: 'MySelf',
    component: MySelf,
  },
  {
    path: '/uploadOss',
    name: 'UploadOss',
    component: UploadOss,
  },
  {
    path: '/aboutOur',
    name: 'AboutOur',
    component: AboutOur,
  },
  {
    path: '/myLike',
    name: 'MyLike',
    component: MyLike,
  },
  {
    path: '/mobileSystemManage',
    name: 'MobileSystemManage',
    component: MobileSystemManage,
  },
  {
    path: '/mobileUserManage',
    name: 'MobileUserManage',
    component: MobileUserManage,
  },
  {
    path: '/mobileAddUser',
    name: 'MobileAddUser',
    component: MobileAddUser,
  },
  {
    path: '/mobileLoginRecord',
    name: 'MobileLoginRecord',
    component: MobileLoginRecord,
  }

];

// 创建 router 实例
const router = createRouter({
  //   history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
});

export default router;
